'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (node) {
	return {
		type: 'DYNAMIC_GRID',
		name: 'Dynamic grid',
		allowedSections: ['main'],
		disallowedChildren: [],
		category: 'Layout',
		props: [{
			name: 'dynamicWidth',
			inputType: 'checkbox',
			label: 'Dynamic width',
			default: false
		}, {
			name: 'gutter',
			inputType: 'select',
			label: 'Gutter',
			default: '0px',
			values: ['0px', '5px', '10px', '15px', '20px', '25px', '30px', '35px', '40px', '45px', '50px']
		}, {
			name: 'transitionDuration',
			inputType: 'number',
			label: 'Transition duration',
			default: '0'
		}],
		hiddenProps: [].concat(_toConsumableArray((0, _applyConfigs2.default)(node && node.props.dynamicWidth === false ? ['columns'] : [])), _toConsumableArray((0, _applyConfigs2.default)(['htmlclass'])))
	};
};